import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { keepParams } from '@homamo/meadow-utils';
import Error from '../../common/ErrorMessage';
import AdminNav from '../../admin/AdminNav';

const AdminUserNotFoundComponent = ({ id, displayError }) => {
  return (
    <>
      <AdminNav />
      <h1>404. User not found</h1>
      <p>No user found with ID: {id}</p>
      <p>
        <Link to={keepParams('/admin/users')}>Back to all users</Link>
      </p>
      {displayError && displayError.message && (
        <>
          <p>
            <small>
              The following information may be useful for technical support:
            </small>
          </p>
          <Error error={displayError} />
        </>
      )}
    </>
  );
};

AdminUserNotFoundComponent.propTypes = {
  id: PropTypes.string.isRequired,
  displayError: PropTypes.shape({
    message: PropTypes.string,
  }),
};

AdminUserNotFoundComponent.defaultProps = {
  displayError: {},
};

export default AdminUserNotFoundComponent;
